var React = require('react');

function Transfer (props) {
    return React.createElement("svg",props,[React.createElement("g",{"transform":"translate(0 0)","key":0},React.createElement("path",{"className":"icon","d":"M13.993,17.809H3.611V16.455a.452.452,0,0,0-.771-.32L.132,18.844a.452.452,0,0,0,0,.638L2.84,22.191a.451.451,0,0,0,.771-.319V20.518H13.993a.452.452,0,0,0,.451-.451V18.261A.451.451,0,0,0,13.993,17.809Z","transform":"translate(0 -16.004)"})),React.createElement("g",{"transform":"translate(0 7.222)","key":1},React.createElement("path",{"className":"a","d":"M14.321,274.824l-2.708-2.709a.452.452,0,0,0-.771.32v1.354H.459a.452.452,0,0,0-.451.451v1.806a.452.452,0,0,0,.451.451H10.841v1.354a.452.452,0,0,0,.771.32l2.708-2.708A.452.452,0,0,0,14.321,274.824Z","transform":"translate(-0.008 -271.983)"}))]);
}

Transfer.defaultProps = {"viewBox":"0 0 14.445 13.542"};

module.exports = Transfer;

Transfer.default = Transfer;
